import { LeftCircleOutlined, RightCircleOutlined } from "@ant-design/icons";
import { Button, Form, Input, Select, Typography } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Alertify from "../../../services/alertify";

const { Title } = Typography;

const AddressStep = (props) => {
  const [form] = Form.useForm();
  const addressData = useSelector((state) => state.admin_dealers);

  const shippinDetails = useMemo(() => {
    return addressData?.dealer_details?.shipping_addresses || [];
  }, [addressData]);
  // console.log(shippinDetails, "fffffff");

  useEffect(() => {
    if (addressData.dealer_details) {
      const billingDetails = addressData.dealer_details.billing_address;
      form.setFieldsValue({
        billAddressLine1: billingDetails?.address,
        billAddressLine2: billingDetails?.address2,
        billCity: billingDetails?.city,
        billPin: billingDetails?.pincode,
        billState: billingDetails?.state,
      });
    }
    if (shippinDetails.length === 0 && addressData.dealer_details) {
      const billingDetails = addressData.dealer_details.billing_address;
      form.setFieldsValue({
        shipAddressLine1: billingDetails?.address,
        shipAddressLine2: billingDetails?.address2,
        shipCity: billingDetails?.city,
        shipPin: billingDetails?.pincode,
        shipState: billingDetails?.state,
        shipName: billingDetails?.name,
        shipName2: billingDetails?.name2,
      });
    }
    const selectedAddressString = props.formData?.shipAddresses;
    if (selectedAddressString) {
      let selectedAddress = null;

      for (let i = 0; i < shippinDetails.length; i++) {
        const address = shippinDetails[i];
        const addressString = `${address.address}, ${address.city}, ${address.state}, ${address.pincode}`;

        if (addressString === selectedAddressString) {
          selectedAddress = address;
          break;
        }
      }

      if (selectedAddress) {
        form.setFieldsValue({
          shipAddresses: props.formData.shipAddresses,
          dealerShipping: selectedAddress.code,
          ship_code: selectedAddress.code,
          shipAddressLine1: selectedAddress.address,
          shipAddressLine2: selectedAddress.address2,
          shipCity: selectedAddress.city,
          shipPin: selectedAddress.pincode,
          shipState: selectedAddress.state,
          shipName: selectedAddress.name,
          shipName2: selectedAddress.name2,
        });
      }
    }
  }, [addressData, form, props.formData, shippinDetails]);

  const handleShippingChange = (value) => {
    const selectedAddress = shippinDetails.find(
      (address) =>
        `${address.address}, ${address.city}, ${address.state}, ${address.pincode}` ===
        value,
    );
    if (selectedAddress) {
      form.setFieldsValue({
        dealerShipping: selectedAddress.code,
        ship_code: selectedAddress.code,
        shipAddressLine1: selectedAddress.address,
        shipAddressLine2: selectedAddress.address2,
        shipCity: selectedAddress.city,
        shipPin: selectedAddress.pincode,
        shipState: selectedAddress.state,
        shipName: selectedAddress.name,
        shipName2: selectedAddress.name2,
      });
    }
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const updatedFormData = { ...props.formData, ...values };
        // console.log("Form Values:", updatedFormData);
        props.onNext(values);
      })
      .catch((errorInfo) => {
        console.error("Validation Failed:", errorInfo);
        Alertify.error("Please fill in all required fields.");
      });
  };
  const handleDraft = () => {
    form
      .validateFields()
      .then((values) => {
        const updatedFormData = { ...props.formData, ...values };
        // console.log("Form Values:", updatedFormData);
        props.onNext(values);
        window.history.back();
      })
      .catch((errorInfo) => {
        console.error("Validation Failed:", errorInfo);
        Alertify.error("Please fill in all required fields.");
      });
  };
  const handlePrevious = () => {
    const values = form.getFieldsValue();
    // console.log("Form Values:", values);
    props.handlePrev(values);
  };
  const [searchText, setSearchText] = useState("");
  const dispatch = useDispatch();

  return (
    <div className="border rounded-lg p-4 w-full">
      <Form form={form} layout="vertical">
        <div className="border p-4 rounded-lg">
          <Title level={3} className="text-left py-4">
            Shipping Address
          </Title>
          <div className="sm:flex">
            <div className="sm:w-[50%] mx-2 text-left">
              {shippinDetails.length !== 0 && (
                <Form.Item
                  label="Shipping Addresses"
                  name="shipAddresses"
                  rules={[
                    {
                      required: true,
                      message: "Please select Shipping Address",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    className="text-left max-w-full"
                    placeholder="Please Select a Shipping Address"
                    onChange={handleShippingChange}
                    options={shippinDetails.map((address, index) => ({
                      key: index,
                      label: `${address.address}, ${address.city}, ${address.state}, ${address.pincode}`,
                      value: `${address.address}, ${address.city}, ${address.state}, ${address.pincode}`,
                    }))}
                  />
                </Form.Item>
              )}
            </div>

            <div className="sm:w-1/2 mx-2">
              <Form.Item label="Address Line 1" name="shipAddressLine1">
                <Input placeholder="Address Line 1" disabled />
              </Form.Item>
              <Form.Item
                className="hidden"
                label="Address Code 1"
                name="dealerShipping"
              >
                <Input placeholder="Address Line 1" disabled />
              </Form.Item>
              <Form.Item
                className="hidden"
                label="Address Code 2"
                name="ship_code"
              >
                <Input placeholder="Address Line 1" disabled />
              </Form.Item>
            </div>
          </div>
          <div className="sm:flex">
            <div className="w-full sm:w-1/2 mx-2">
              <Form.Item label="Address Line 2" name="shipAddressLine2">
                <Input placeholder="Address Line 2" disabled />
              </Form.Item>
            </div>
            <div className="w-full sm:w-1/2 mx-2">
              <Form.Item label="State" name="shipState">
                <Input placeholder="State" disabled />
              </Form.Item>
            </div>
            <div className="w-full sm:w-1/2 mx-2 hidden">
              <Form.Item label="Ship name" name="shipName">
                <Input placeholder="Ship name 2" disabled />
              </Form.Item>
            </div>
            <div className="w-full sm:w-1/2 mx-2 hidden">
              <Form.Item label="Ship name 2" name="shipName2">
                <Input placeholder="Ship name 2" disabled />
              </Form.Item>
            </div>
          </div>
          <div className="sm:flex">
            <div className="w-full sm:w-1/2 mx-2">
              <Form.Item label="City" name="shipCity">
                <Input placeholder="City" disabled />
              </Form.Item>
            </div>
            <div className="w-full sm:w-1/2 mx-2">
              <Form.Item label="PIN Code" name="shipPin">
                <Input placeholder="123456" disabled />
              </Form.Item>
            </div>
          </div>
        </div>
        <div className="border p-4 rounded-lg my-4">
          <Title level={3} className="text-left py-4">
            Billing Address
          </Title>
          <div className="sm:flex">
            <div className="w-full mx-2">
              <Form.Item label="Address Line 1" name="billAddressLine1">
                <Input placeholder="Address Line 1" disabled />
              </Form.Item>
            </div>
            <div className="w-full mx-2">
              <Form.Item label="Address Line 2" name="billAddressLine2">
                <Input placeholder="Address Line 2" disabled />
              </Form.Item>
            </div>
          </div>
          <div className="sm:flex">
            <div className="w-full mx-2">
              <Form.Item label="State" name="billState">
                <Input placeholder="State" disabled />
              </Form.Item>
            </div>
            <div className="w-full mx-2">
              <Form.Item label="City" name="billCity">
                <Input placeholder="City" disabled />
              </Form.Item>
            </div>
          </div>
          <div className="sm:flex">
            <div className="w-full sm:w-1/2 mx-2">
              <Form.Item label="PIN Code" name="billPin">
                <Input placeholder="123456" disabled />
              </Form.Item>
            </div>
          </div>
        </div>
        <div className="flex justify-between items-center w-full">
          <Button
            className="text-md rounded-lg"
            onClick={handlePrevious}
            disabled={props.currentStep <= 0}
          >
            <LeftCircleOutlined className="mb-[-3px]" /> PREVIOUS
          </Button>
          <div>
            <Button
              className="text-md rounded-lg mr-4"
              type="primary"
              htmlType="submit"
              onClick={handleDraft}
            >
              SAVE DRAFT
            </Button>
            <Button
              className="text-md rounded-lg"
              type="primary"
              // htmlType="submit"
              onClick={handleSubmit}
            >
              NEXT <RightCircleOutlined className="mb-[-3px]" />
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default AddressStep;
